import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { Button } from "../../base/button/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter } from "../../base/dialog/dialog";
import { ExcelUploadSurface } from "./excel-upload-surface";
/**
 * The one template-download + dropzone modal for every Excel bulk upload. The
 * caller's `parse` does the parsing and merges into its own state; the dialog
 * only drives the file input, the success/failure toast, and closing.
 */ export function ExcelUploadDialog({ open, onOpenChange, title, description, downloadTemplate, parse, errorToast, showSuccessToast = true, accept }) {
    const { t } = useTranslation();
    return /*#__PURE__*/ _jsx(Dialog, {
        open: open,
        onOpenChange: onOpenChange,
        children: /*#__PURE__*/ _jsxs(DialogContent, {
            className: "max-w-[520px]",
            children: [
                /*#__PURE__*/ _jsxs(DialogHeader, {
                    children: [
                        /*#__PURE__*/ _jsx(DialogTitle, {
                            className: "text-lg font-bold text-foreground",
                            children: title
                        }),
                        description && /*#__PURE__*/ _jsx(DialogDescription, {
                            children: description
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "space-y-4.5",
                    children: /*#__PURE__*/ _jsx(ExcelUploadSurface, {
                        downloadTemplate: downloadTemplate,
                        parse: parse,
                        onParsed: ()=>onOpenChange(false),
                        errorToast: errorToast,
                        showSuccessToast: showSuccessToast,
                        showDivider: true,
                        accept: accept
                    })
                }),
                /*#__PURE__*/ _jsx(DialogFooter, {
                    children: /*#__PURE__*/ _jsx(Button, {
                        variant: "outline",
                        size: "medium",
                        onClick: ()=>onOpenChange(false),
                        children: t("common.back")
                    })
                })
            ]
        })
    });
}

//# sourceMappingURL=excel-upload-dialog.js.map